import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { createCmsStart, createPromotionStart } from '../../../../store/redux-slices/tenantsFetchData'
import { useEffect, useState } from 'react'
import { deleteCMSLanguageStart, getCMSDynamicKeysStart, updatePromotionsStart, updateSuperAdminCMSStart } from '../../../../store/redux-slices/fetchData'
import { getImageGalleryStart } from '../../../../store/redux-slices/emailTemplate'
import { getCMSLanguagesStart, getLanguagesStart } from '../../../../store/redux-slices/languages'

const useCreatePromotions = (cmsData) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { cmsPageId } = useParams()

  const [selectedClient, setSelectedClient] = useState(cmsData ? cmsData?.adminUserId : '')
  const [selectedPortal, setSelectedPortal] = useState(cmsData ? cmsData?.tenantId : '')
  const [err, setErr] = useState('')
  const [selectedTab, setSelectedTab] = useState('EN')
  const [template, setTemplate] = useState('')
  const [galleryModal, setGalleryModal] = useState('')
  const [isTouched, setIsTouched] = useState({ client: false, portal: true })

  const { loading } = useSelector((state) => state.tenantsFetch)
  const { cmsKeys } = useSelector((state) => state.fetch)
  const { languages:tenantLanguages } = useSelector((state) => state.languages)

  const getGalleryData = () => {
    dispatch(getImageGalleryStart({ isTenant: false }))
  }

  useEffect(() => {
    dispatch(getCMSDynamicKeysStart({ isTenant: false }))
    dispatch(getLanguagesStart({ limit:'', pageNo:'', name:"" }))

  }, [])

  useEffect(() => {
    if (!tenantLanguages?.length || !tenantLanguages.includes(selectedTab)) {
      setSelectedTab('EN')
    }
  }, [tenantLanguages])

  useEffect(() => {
    dispatch(getCMSLanguagesStart({ adminId: selectedClient, tenantId: selectedPortal }))
  }, [selectedClient, selectedPortal])

  const createPromotions = (data) => dispatch(createPromotionStart({ promotionsData: data, navigate }))
  const editPromotions = (data) => dispatch(updatePromotionsStart({ promotionsData: data, navigate }))
  const deleteCms = (data) => dispatch(deleteCMSLanguageStart({ isTenant: false, data }))

  return {
    navigate,
    loading,
    selectedClient,
    selectedPortal,
    setSelectedClient,
    setSelectedPortal,
    isTouched,
    setIsTouched,
    err,
    setErr,
    editPromotions,
    cmsPageId,
    template,
    setTemplate,
    galleryModal,
    setGalleryModal,
    getGalleryData,
    cmsKeys,
    selectedTab,
    setSelectedTab,
    languages: tenantLanguages,
    deleteCms,
    createPromotions
  }
}

export default useCreatePromotions
